export default __webpack_public_path__ + "static/media/ic-arrowGray.a7cd8394.svg";